import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { relations } from 'drizzle-orm';
import { user } from './auth.js';
import { locations, sections, wards } from './locations.js';
import { uuidv7 } from './utils/uuidv7.js';
export const userAccessLocation = pgTable('user_access_location', {
    id: uuidv7('id').primaryKey(),
    userId: uuid('user_id')
        .notNull()
        .references(() => user.id, { onDelete: 'cascade' }),
    locationId: uuid('location_id')
        .notNull()
        .references(() => locations.id, { onDelete: 'cascade' }),
    sectionId: uuid('section_id').references(() => sections.id, { onDelete: 'cascade' }),
    wardId: uuid('ward_id').references(() => wards.id, { onDelete: 'cascade' }),
    // better-auth 1.7's organization member model
    role: text('role').default('member'),
    createdAt: timestamp('created_at').defaultNow().notNull(),
}, t => [
    // the actor/permission graph loads a user's access rows
    index('idx_user_access_location_user').on(t.userId),
    index('idx_user_access_location_location').on(t.locationId),
    index('idx_user_access_location_section').on(t.sectionId),
    index('idx_user_access_location_ward').on(t.wardId),
]);
export const userAccessLocationRelations = relations(userAccessLocation, ({ one }) => ({
    user: one(user, {
        fields: [userAccessLocation.userId],
        references: [user.id],
    }),
    location: one(locations, {
        fields: [userAccessLocation.locationId],
        references: [locations.id],
    }),
    section: one(sections, {
        fields: [userAccessLocation.sectionId],
        references: [sections.id],
    }),
    ward: one(wards, {
        fields: [userAccessLocation.wardId],
        references: [wards.id],
    }),
}));
//# sourceMappingURL=user-access-location.js.map